import React, { useState } from 'react';
import { AddButton, Button, Container, Discount, Icons, Image, Review, Title, Wrapper } from './style';
import { farmData } from '../../mock/farmCardData';
import Rating from '../Rating'
const FarmCard = () => {
    const [count, setCount] = useState(0);

    const increase = () => {
        setCount(count + 1)
    }
    const decrement = () => {
        if (count > 0) {
            setCount(count - 1)
        }
    }
    return (
        <Container main>
            <Container>
                <Image>
                    {farmData.map((value) => {
                        return (
                            <Wrapper sale key={value.id}>
                                <Discount>
                                    {value.sale}
                                </Discount>
                                <Discount shipping>
                                    {value.shipping}
                                </Discount>
                            </Wrapper>
                        )
                    })}
                </Image>

                {/* Header*/}

                {farmData.map((value) => {
                    return (
                        <Wrapper key={value.id}>
                            <Title title>{value.title}</Title>
                            <Wrapper rating>
                                <Rating color='#FDBC15' />
                                <Review>({value.review})</Review>
                            </Wrapper>
                            <Title desc>{value.desc}</Title>
                            {/* Category */}
                            {farmData.map((value) => {
                                return (
                                    <Wrapper mainCategory >
                                        <Wrapper>
                                            <Wrapper category>
                                                <Title categoryTitle>SKU:</Title>
                                                <Title categoryDesc >{value.orderNumber}</Title>
                                            </Wrapper>
                                            <Wrapper category>
                                                <Title categoryTitle>Category:</Title>
                                                <Title categoryDesc>{value.categories}</Title>
                                            </Wrapper>
                                            <Wrapper category>
                                                <Title categoryTitle >Stock:</Title>
                                                <Title categoryDesc stock>{value.stock}</Title>
                                            </Wrapper>
                                            <Wrapper category>
                                                <Title categoryTitle>Farm:</Title>
                                                <Title categoryDesc >{value.farm}</Title>
                                            </Wrapper>
                                        </Wrapper>
                                        <Wrapper>

                                            <Wrapper category>
                                                <Title categoryTitle>Freshness:</Title>
                                                <Title categoryDesc >{value.Freshness}</Title>
                                            </Wrapper>
                                            <Wrapper category>
                                                <Title categoryTitle>Buy by:</Title>
                                                <Title categoryDesc>{value.buying}</Title>
                                            </Wrapper>
                                            <Wrapper category>
                                                <Title categoryTitle>Delivery:</Title>
                                                <Title categoryDesc >{value.delivery}</Title>
                                            </Wrapper>
                                            <Wrapper category>
                                                <Title categoryTitle>Delivery area:</Title>
                                                <Title categoryDesc >{value.deliveryArea}</Title>
                                            </Wrapper>
                                        </Wrapper>
                                    </Wrapper>
                                )
                            })}
                            <Wrapper buttonWrapper>
                                <Wrapper price>
                                    <Title price>{value.price} </Title>
                                    <Title discount>{value.discount} </Title>
                                </Wrapper>
                                <Wrapper button>
                                    <Button onClick={decrement}>-</Button>
                                    {count}
                                    <Button onClick={increase}>+</Button>
                                </Wrapper>
                                <AddButton>Add to cart</AddButton>
                            </Wrapper>

                            <Wrapper action>
                                <Wrapper wishlist>
                                    <Icons.HeartIcon />
                                    {value.wishlist}
                                </Wrapper>
                                <Wrapper wishlist>
                                    <Icons.Compare />
                                    {value.compare}
                                </Wrapper>
                            </Wrapper>
                        </Wrapper>
                    )
                })}


            </Container>

        </Container>
    )
}

export default FarmCard;